import { IAssignee } from "@gtmhub/assignees";
import { actionHandlerGenerator } from "@gtmhub/shared/utils";
import { StateService } from "@uirouter/angularjs";
import { IController, IComponentOptions, IWindowService } from "angular";
import { ItemAction } from "../models";

export type AvatarSize = "s-16" | "s-20" | "s-22" | "s-24" | "s-26" | "s-32" | "s-40" | "s-70";

type ICircleAvatarAction = ItemAction & {
  disable?: boolean;
};

/**
 * @example <circle-avatar assignee="$ctrl.assignees[ownerId]" size="s-20" show-tooltip="true" tooltip-placement="bottom"></circle-avatar>
 * @param assignee IAssignee
 * @param size "s-16" | "s-20" | "s-22" | "s-24" | "s-26" | "s-70"
 * @param showTooltip boolean
 * @param tooltipPlacement "top" | "bottom" | "left" | "right"
 * @param action ICircleAvatarAction
 */
export class CircleAvatarCtrl implements IController {
  // Bindings
  assignee: IAssignee;
  size: AvatarSize;
  showTooltip: boolean;
  tooltipPlacement: "top" | "bottom" | "left" | "right";
  action: ICircleAvatarAction;

  actionHandler: () => unknown;

  static $inject = ["$state", "$window"];

  constructor(private $state: StateService, private $window: IWindowService) {}

  $onInit(): void {
    if (this.action && !this.action.disable) {
      this.actionHandler = actionHandlerGenerator(this.action, { $state: this.$state, $window: this.$window });
    }
  }
}

export const CircleAvatarComponent: IComponentOptions = {
  controller: CircleAvatarCtrl,
  templateUrl: require("./circle-avatar.jade"),
  transclude: true,
  bindings: {
    assignee: "<",
    size: "@",
    showTooltip: "<",
    tooltipPlacement: "@",
    action: "<",
  },
};
